<template>
  <div class="testPaper">
    <div class="testPaperWrap">
      <div class="left">
        <div class="header">
          <div class="title">{{ detail.paperTitle }}</div>
          <div class="testDetail">
            <span>试题数量：{{ detail.questionTotal }}道</span>
            <span class="testTime"
              >考试时间：{{ detail.examDurationTime }}分钟</span
            >
            <span>满分：{{ detail.fullScore }}分</span>
          </div>
        </div>
        <div class="footer">
          <el-button class="signListUp" @click="signListUp" v-if="num !== 0"
            >上一题</el-button
          >
          <el-button
            class="signListNext"
            @click="signListNext"
            v-if="num + 1 !== list.length"
            >下一题</el-button
          >
          <el-button
            class="signListNext"
            @click="submit"
            v-if="num + 1 == list.length"
            >交卷</el-button
          >
        </div>
        <div class="quertionWrap">
          <component
            :is="questionComponentMap[list[num].questionType - 1]"
            :data="list[num]"
            :num="num"
            :all-arr="detail.questionList"
          ></component>
          <!-- <Single
            :datas="single"
            :num="num"
            :allArr="detail.questionList"
          ></Single>
          <Multiple
            :datas="multiple"
            :num="num"
            :allArr="detail.questionList"
          ></Multiple>
          <ShortAnswer
            :datas="calculation"
            :num="num"
            :allArr="detail.questionList"
          ></ShortAnswer>
          <Single
            :datas="judgeList"
            :num="num"
            :allArr="detail.questionList"
          ></Single>
          <Completion
            :datas="completion"
            :num="num"
            :allArr="detail.questionList"
          ></Completion>
          <ShortAnswer
            :datas="shortAnswer"
            :num="num"
            :allArr="detail.questionList"
          ></ShortAnswer>
          <ShortAnswer
            :datas="discuss"
            :num="num"
            :allArr="detail.questionList"
          ></ShortAnswer>
          <ShortAnswer
            :datas="caseAnalysis"
            :num="num"
            :allArr="detail.questionList"
          ></ShortAnswer>
          <ShortAnswer
            :datas="comprehensive"
            :num="num"
            :allArr="detail.questionList"
          ></ShortAnswer> -->
        </div>
      </div>
      <div class="right">
        <div class="rightTop">
          <div>距考试结束</div>
          <div class="time">{{ timenow }}</div>
        </div>
        <div class="rightContent">
          <!-- <div
            v-for="(item, index) in list"
            :key="index"
            class="choiceItem"
            :class="[
              { nowActive: num == index },
              {
                choiceActive:
                  item.questionType == 2 && item.checkbox.length !== 0,
              },
              {
                choiceActive:
                  (item.questionType == 1 || item.questionType == 4) &&
                  item[
                    ['signListRadio', '', '', 'judgeListRadio'][
                      item.questionType - 1
                    ]
                  ] !== '',
              },
              {
                choiceActive:
                  (item.questionType == 3 ||
                    item.questionType == 5 ||
                    item.questionType == 6 ||
                    item.questionType == 7 ||
                    item.questionType == 8 ||
                    item.questionType == 9) &&
                  item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
              },
            ]"
            @click="answerCard(index)"
          >
            {{ index + 1 }}
          </div> -->
          <div v-if="single.length > 0" class="testBox">
            <div class="testType">单选题</div>
            <div
              @click="answerCard(index)"
              v-for="(item, index) in single"
              :key="index"
              class="choiceItem"
              :class="[
                { nowActive: num == index },
                {
                  choiceActive:
                    item[
                      ['signListRadio', '', '', 'judgeListRadio'][
                        item.questionType - 1
                      ]
                    ] !== '',
                },
              ]"
            >
              {{ index + 1 }}
            </div>
          </div>
          <div v-if="multiple.length > 0" class="testBox">
            <div class="testType">多选题</div>
            <div
              @click="answerCard(index + single.length)"
              v-for="(item, index) in multiple"
              :key="index"
              class="choiceItem"
              :class="[
                { nowActive: num == index + single.length },
                {
                  choiceActive: item.checkbox.length !== 0,
                },
              ]"
            >
              {{ index + 1 + single.length }}
            </div>
          </div>
          <div v-if="calculation.length > 0" class="testBox">
            <div class="testType">计算题</div>
            <div
              @click="answerCard(index + single.length + multiple.length)"
              v-for="(item, index) in calculation"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive: num == index + single.length + multiple.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{ index + 1 + single.length + multiple.length }}
            </div>
          </div>
          <div v-if="judgeList.length > 0" class="testBox">
            <div class="testType">判断题</div>
            <div
              @click="
                answerCard(
                  index + single.length + multiple.length + calculation.length
                )
              "
              v-for="(item, index) in judgeList"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length,
                },
                {
                  choiceActive:
                    item[
                      ['signListRadio', '', '', 'judgeListRadio'][
                        item.questionType - 1
                      ]
                    ] !== '',
                },
              ]"
            >
              {{
                index + 1 + single.length + multiple.length + calculation.length
              }}
            </div>
          </div>
          <div v-if="completion.length > 0" class="testBox">
            <div class="testType">填空题</div>
            <div
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length
                )
              "
              v-for="(item, index) in completion"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{
                index +
                1 +
                single.length +
                multiple.length +
                calculation.length +
                judgeList.length
              }}
            </div>
          </div>
          <div v-if="shortAnswer.length > 0" class="testBox">
            <div class="testType">简答题</div>
            <div
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length
                )
              "
              v-for="(item, index) in shortAnswer"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{
                index +
                1 +
                single.length +
                multiple.length +
                calculation.length +
                judgeList.length +
                completion.length
              }}
            </div>
          </div>
          <div v-if="discuss.length > 0" class="testBox">
            <div class="testType">论述题</div>
            <div
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length
                )
              "
              v-for="(item, index) in discuss"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{
                index +
                1 +
                single.length +
                multiple.length +
                calculation.length +
                judgeList.length +
                completion.length +
                shortAnswer.length
              }}
            </div>
          </div>
          <div v-if="caseAnalysis.length > 0" class="testBox">
            <div class="testType">案列分析题</div>
            <div
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length +
                    discuss.length
                )
              "
              v-for="(item, index) in caseAnalysis"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length +
                      discuss.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{
                index +
                1 +
                single.length +
                multiple.length +
                calculation.length +
                judgeList.length +
                completion.length +
                shortAnswer.length +
                discuss.length
              }}
            </div>
          </div>
          <div v-if="comprehensive.length > 0" class="testBox">
            <div class="testType">综合题</div>
            <div
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length +
                    discuss.length +
                    caseAnalysis.length
                )
              "
              v-for="(item, index) in comprehensive"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length +
                      discuss.length +
                      caseAnalysis.length,
                },
                {
                  choiceActive:
                    item.optionList.filter((v) => v.answer).length ==
                    item.optionList.length,
                },
              ]"
            >
              {{
                index +
                1 +
                single.length +
                multiple.length +
                calculation.length +
                judgeList.length +
                completion.length +
                shortAnswer.length +
                discuss.length +
                caseAnalysis.length
              }}
            </div>
          </div>
        </div>
        <div class="rightFooter">
          <div class="submitBtn" @click="submit">交卷</div>
        </div>
      </div>
    </div>
    <dialogType ref="dialogType"></dialogType>
  </div>
</template>

<script>
import Single from "./components/Single";
import Multiple from "./components/Multiple";
import ShortAnswer from "./components/ShortAnswer";
import Completion from "./components/Completion";
import dialogType from "./components/Dialog.vue";
import { getQuestion, oneQuestionSumit, submitTest } from "@/api/exam";
import to from "await-to";
export default {
  components: {
    dialogType,
    Single,
    Multiple,
    ShortAnswer,
    Completion,
  },
  data() {
    return {
      list: [{}],
      leaveStatus: 0,
      detail: {},
      single: [], //单选1
      multiple: [], //多选2
      calculation: [], //计算3
      judgeList: [], //判断4
      completion: [], //填空5
      shortAnswer: [], //简答6
      discuss: [], //论述7
      caseAnalysis: [], //案例分析8
      comprehensive: [], //综合
      num: 0,
      timenow: "",
      limitTestTime: null,
      intervalInstance: null,
      time: "",
      questionComponentMap: [
        "Single",
        "Multiple",
        "ShortAnswer",
        "Single",
        "Completion",
        "ShortAnswer",
        "ShortAnswer",
        "ShortAnswer",
        "ShortAnswer",
      ],
    };
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.leaveStatus == 0) {
  //     this.$refs.dialogType.show("leaveDialog");
  //   } else {
  //     next();
  //   }
  // },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
    this.intervalInstance && clearInterval(this.intervalInstance);
    this.limitTestTime && clearInterval(this.limitTestTime);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
    this.getQuestionData();
  },
  methods: {
    async getQuestionData() {
      const { examPlanId, examSubjectId } = this.$route.query;
      const [res, err] = await to(
        getQuestion({
          examPlanId: examPlanId,
          examSubjectId: examSubjectId,
          userSubjectToken: this.$route.query.t,
        })
      );
      if (err) {
        if ([243509, 243510, 243511, 243512].includes(err.code)) {
          return this.$confirm(err.msg, "提示", {
            confirmButtonText: "返回",
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: "warning",
          })
            .then(() => {
              this.leaveStatus = 1;
              this.$router.replace("/exam/examCenter");
            })
            .catch(() => {
              this.leaveStatus = 1;
              this.$router.replace("/exam/examCenter");
            });
        } else {
          return this.$message.warning(err.msg);
        }
      }
      this.detail = res.data;
      this.initCountDown();
      this.single = res.data.questionList.filter((item) => {
        this.$set(item, "signListRadio", "");
        return item.questionType == 1;
      });
      this.multiple = res.data.questionList.filter((item) => {
        this.$set(item, "checkbox", []);
        return item.questionType == 2;
      });
      this.calculation = res.data.questionList.filter((item) => {
        return item.questionType == 3;
      });
      this.judgeList = res.data.questionList.filter((item) => {
        this.$set(item, "judgeListRadio", "");
        return item.questionType == 4;
      });
      this.completion = res.data.questionList.filter((item) => {
        return item.questionType == 5;
      });
      this.shortAnswer = res.data.questionList.filter((item) => {
        return item.questionType == 6;
      });
      this.discuss = res.data.questionList.filter((item) => {
        return item.questionType == 7;
      });
      this.caseAnalysis = res.data.questionList.filter((item) => {
        return item.questionType == 8;
      });
      this.comprehensive = res.data.questionList.filter((item) => {
        return item.questionType == 9;
      });
      this.list = [
        ...this.single,
        ...this.multiple,
        ...this.calculation,
        ...this.judgeList,
        ...this.completion,
        ...this.shortAnswer,
        ...this.discuss,
        ...this.caseAnalysis,
        ...this.comprehensive,
      ];
      this.time = this.detail.submitLeftTime;
      this.limitTestTime = setInterval(() => {
        this.time--;
      }, 1000);
      var questionObj = {
        1: "signListRadio",
        2: "checkbox",
        4: "judgeListRadio",
      };
      this.list.map((v, index) => {
        let arr = [];
        if (v.questionId == this.detail.lastQuestionId) {
          this.num = index;
        }
        v.optionList.map((el) => {
          if (el.checked && (v.questionType == 1 || v.questionType == 4)) {
            this.$set(v, questionObj[v.questionType], el.optionId);
          } else if (el.checked && v.questionType == 2) {
            arr.push(el.optionId);
            // console.log(arr);
            this.$set(v, "checkbox", arr);
          }
        });
      });
    },
    async oneQuestionSumit(type = "") {
      return new Promise((resolve, reject) => {
        var item = this.list[this.num];
        var obj = {
          1: "signListRadio",
          2: "checkbox",
          4: "judgeListRadio",
        };
        var answerList = [];
        if (
          item.questionType == 1 ||
          item.questionType == 2 ||
          item.questionType == 4
        ) {
          if (item.questionType == 1 || item.questionType == 4) {
            answerList = [
              { answer: "", optionId: item[obj[item.questionType]] },
            ];
          } else if (item.questionType == 2) {
            item.checkbox.map((v) => {
              answerList.push({
                answer: "",
                optionId: v,
              });
            });
          }
        } else {
          item.optionList.map((v) => {
            answerList.push({
              answer: v.answer,
              optionId: v.optionId,
            });
          });
        }
        oneQuestionSumit({
          answerList,
          examRecordId: this.detail.examRecordId,
          questionId: item.questionId,
        })
          .then((res) => {
            this.leaveStatus = 1;
            // item.optionList.map((v) => {
            //   if (item.questionType == 1 || item.questionType == 4) {
            //     if (v.optionId == item[obj[item.questionType]]) {
            //       v.checked = true;
            //     } else if (item.questionType == 2) {
            //       item.checkbox.map((el) => {
            //         if (v.optionId == el) {
            //           v.checked = true;
            //         }
            //       });
            //     }
            //   }
            // });
            console.log(item);
            if (type != "answerCard") {
              this.num += 1;
            }
            resolve(res);
          })
          .catch((err) => {
            this.$message.warning(err.msg);
            reject(err);
          });
      });
    },
    signListUp() {
      this.num -= 1;
    },
    signListNext() {
      this.oneQuestionSumit();
    },
    async submit() {
      const [, error] = await to(this.oneQuestionSumit("answerCard"));
      if (error) return;
      // let time = new Date().getTime();
      // if (
      //   time <
      //   this.detail.startTime + this.detail.commitPaperTime * 60 * 1000
      // ) {
      //   this.$refs.dialogType.show(
      //     "testTimeDialog",
      //     this.detail.commitPaperTime
      //   );
      //   return;
      // }
      if (this.time > 0) {
        this.$refs.dialogType.show(
          "testTimeDialog",
          this.detail.commitPaperTime
        );
        return;
      }
      var obj = {
        1: "signListRadio",
        2: "checkbox",
        4: "judgeListRadio",
      };
      var arr = [];
      this.list.map((item) => {
        this.$set(item, "Ischeck", false);
        if (
          item.questionType == 1 ||
          item.questionType == 4 ||
          item.questionType == 2
        ) {
          if (
            item[obj[item.questionType]] != "" ||
            item[obj[item.questionType]].length != []
          ) {
            this.$set(item, "Ischeck", true);
            arr.push(item);
          }
        } else {
          if (
            item.optionList.filter((v) => v.answer).length ==
            item.optionList.length
          ) {
            this.$set(item, "Ischeck", true);
            arr.push(item);
          }
        }
      });
      for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i];
        if (!item.Ischeck) {
          this.$refs.dialogType.show(
            "surplusDialog",
            this.list.length - arr.length
          );
          return false;
        }
      }
      this.$refs.dialogType.show("sureDialog", "");
    },
    async allQuestionSubmit() {
      const [, error] = await to(this.oneQuestionSumit());
      if (error) return;
      const [, err] = await to(
        submitTest({
          examRecordId: this.detail.examRecordId,
        })
      );
      if (err) return this.$message.warning(err.msg);
      this.$router.push("/exam/success");
    },
    async answerCard(index) {
      // await this.oneQuestionSumit(this.list[this.num], "answerCard");
      const [, error] = await to(this.oneQuestionSumit("answerCard"));
      if (error) return;
      this.num = index;
      console.log(this.num);
    },
    initCountDown() {
      var startCount = this.detail.leftTime;
      this.intervalInstance = setInterval(() => {
        startCount--;
        let hour = parseInt(startCount / 3600);
        if (hour < 10) {
          hour = "0" + hour;
        }
        let minute = parseInt(startCount / 60) % 60;
        if (minute < 10) {
          minute = "0" + minute;
        }
        let second = startCount % 60;
        if (second < 10) {
          second = "0" + second;
        }
        this.timenow = hour + ":" + minute + ":" + second;
        if (startCount == 300) {
          this.$refs.dialogType.show("fiveTimeDialog", 5);
        }
        if (startCount === 0) {
          clearInterval(this.intervalInstance);
          this.allQuestionSubmit();
        }
      }, 1000);
    },
    goBack() {
      if (this.leaveStatus == 0) {
        history.pushState(null, null, document.URL);
        this.$refs.dialogType.show("leaveDialog", this.detail.paperTitle);
      } else {
        this.go();
      }
    },
    go() {
      this.$router.push({ path: "/exam/examCenter" });
    },
  },
};
</script>

<style scoped lang="scss">
.testPaper {
  height: 100vh;
  background-color: #f5f7fa;
  .choiceActive {
    background-color: #e6effa !important;
    color: #3671bf !important;
  }
  .testPaperWrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    box-sizing: border-box;
    height: 100%;
    display: flex;
  }
  .left {
    width: 880px;
    margin-right: 30px;
    background-color: #fff;
    position: relative;
    .header {
      padding-top: 20px;
      box-sizing: border-box;
      height: 110px;
      text-align: center;
      border-bottom: 1px solid #e8ebf2;
      .title {
        font-size: 30px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .testDetail {
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #909399;
        .testTime {
          display: inline-block;
          margin: 10px 70px 0;
        }
      }
    }
    .footer {
      z-index: 99;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 880px;
      height: 60px;
      background: #ffffff;
      box-shadow: 0px -2px 10px 1px #e7ebf2;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-button {
        width: 100px;
      }
      .signListNext {
        background-color: #3671bf;
        color: #fff;
      }
      .signListUp {
        margin-right: 40px;
        border: 1px solid #3671bf;
        color: #3671bf;
      }
    }
    .quertionWrap {
      height: calc(100% - 110px);
      overflow: auto;
      padding: 30px 30px 80px;
      box-sizing: border-box;
    }
  }
  .right {
    width: 290px;
    height: 610px;
    overflow-y: auto;
    background-color: #fff;
    .nowActive {
      background-color: #3671bf !important;
      color: #fff !important;
    }
    .rightTop {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #4d4d4d;
      border-bottom: 1px solid #e8ebf2;
      .time {
        margin-left: 64px;
        font-weight: bold;
        color: #ff6c6b;
        font-size: 24px;
      }
    }
    .rightContent {
      height: calc(100% - 135px);
      overflow-x: hidden;
      overflow-y: auto;
      padding: 20px 0;
      box-sizing: border-box;
      .testBox {
        overflow: hidden;
        .testType {
          margin-left: 20px;
          padding-left: 8px;
          box-sizing: border-box;
          font-size: 16px;
          margin-bottom: 20px;
          color: #666;
          position: relative;
          &::before {
            content: "";
            width: 3px;
            height: 16px;
            background-color: #3179e4;
            margin-right: 5px;
            position: absolute;
            left: 0;
            top: 5px;
          }
        }
      }
      .choiceItem {
        width: 36px;
        line-height: 28px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #e6e8ed;
        text-align: center;
        float: left;
        cursor: pointer;
        margin-left: 16px;
        margin-bottom: 16px;
      }
    }
    .rightFooter {
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      .submitBtn {
        width: 160px;
        line-height: 40px;
        background: #3671bf;
        border-radius: 4px 4px 4px 4px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
